module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/cover-hakone-3-28de1efa5e5fc30126db9ba359395558.webp";